<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.seller && localService.languageContent.receipt">
    <div class="center" style="max-width:1000px;">
        <div class="banner">
            <div class="row">
                <div class="col-2">
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.type}}"
                        [(ngModel)]="data.v2" style="width:100%"
                        placeholder="*{{localService.languageContent.receipt.type}}"
                        title="*{{localService.languageContent.receipt.type}}" [ngClass]="data.v2 ? 'en' : ''" />
                </div>
                <div class="col-8">
                    <input autocomplete="off" type="text" [(ngModel)]="data.v1"
                        title="*{{localService.languageContent.receipt.name}}" id="{{elementIds.title}}"
                        placeholder="*{{localService.languageContent.receipt.name}}" />
                </div>
                <div class="col-2">
                    <button type="button" class="btn btn-primary" [id]="elementIds.save" (click)="onAction(1)">
                        {{localService.languageContent.common.add}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <textarea id="{{elementIds.html}}" rows="5" [(ngModel)]="data.v4"
                        title="*{{localService.languageContent.receipt.html}}"
                        placeholder="*{{localService.languageContent.receipt.html}}"></textarea>
                </div>
            </div>
        </div>
        <div class="banner" *ngFor="let item of items; let i = index" style="margin-top: 10px;">
            <div class="row">
                <div class="col-2">
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.type + '_' + i}}"
                        [(ngModel)]="item.v2" style="width:100%"
                        placeholder="*{{localService.languageContent.receipt.type}}"
                        title="*{{localService.languageContent.receipt.type}}" [ngClass]="item.v2 ? 'en' : ''" />
                </div>
                <div class="col-8">
                    <input autocomplete="off" type="text" [(ngModel)]="item.v1"
                        title="*{{localService.languageContent.receipt.name}}" id="{{elementIds.title + '_' + i}}"
                        placeholder="*{{localService.languageContent.receipt.name}}" />
                </div>
                <div class="col-2">
                    <button type="button" class="btn btn-primary" [id]="elementIds.save + '_' + i" (click)="onAction(1, item.key)">
                        {{localService.languageContent.common.update}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <textarea id="{{elementIds.html + '_' + i}}" rows="5" [(ngModel)]="item.v4"
                        title="*{{localService.languageContent.receipt.html}}"
                        placeholder="*{{localService.languageContent.receipt.html}}"></textarea>
                </div>
            </div>
        </div>
    </div>
</div>